import React, { useRef } from 'react';
import { ReceiptRefundIcon } from '@heroicons/react/24/outline';
import DialogShell from './dialog-shell';
import { TWButton, FieldLabel, IconBadge } from '../../../../components/ui';
import { formatCurrency } from '../../../../utils/baseUtils';

const RefundDialog = ({
  open,
  onClose,
  form,
  errors,
  loading,
  onChange,
  onSubmit,
  orderDetail,
}) => {
  const cancelRef = useRef(null);
  const remaining = (orderDetail.total || 0) - (orderDetail.refund || 0);
  const max = orderDetail.total || 0;

  return (
    <DialogShell
      open={open}
      onClose={onClose}
      maxWidth="sm:max-w-md"
      initialFocus={cancelRef}
    >
      <div className="px-6 pt-6">
        <div className="flex items-center gap-3">
          <IconBadge icon={ReceiptRefundIcon} tone="rose" size="md" />
          <div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
              Issue Refund
            </h2>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Available balance:{' '}
              <span className="font-semibold tabular-nums">
                {formatCurrency(remaining)}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 px-6 py-5">
        <FieldLabel htmlFor="refund-amount">Refund Amount</FieldLabel>
        <div className="relative">
          <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-sm font-semibold text-slate-400">
            $
          </span>
          <input
            id="refund-amount"
            type="number"
            value={form.refund}
            onChange={(e) => onChange(e.target.value, 'refund')}
            placeholder="0.00"
            className="block w-full rounded-md border border-slate-200 bg-white py-3 pl-8 pr-4 text-base font-semibold tabular-nums text-slate-900 placeholder:text-slate-400 shadow-sm transition focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-sky-400 dark:focus:ring-sky-400"
          />
        </div>
        {errors.refund && (
          <p className="text-xs font-medium text-rose-600 dark:text-rose-400">
            You can&apos;t refund more than {formatCurrency(max)}
          </p>
        )}
      </div>

      <div className="flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-6 py-4 dark:border-slate-700 dark:bg-slate-900/40">
        <TWButton
          ref={cancelRef}
          label="Cancel"
          disabled={loading}
          onClick={onClose}
        />
        <TWButton
          variant="danger"
          label="Issue Refund"
          loading={loading}
          disabled={loading}
          onClick={onSubmit}
        />
      </div>
    </DialogShell>
  );
};

export default RefundDialog;
